export default __webpack_public_path__ + "static/media/coding.b96630f9.png";